fragment ComparisonFragment on Comparison {
    id
    shouldCompareSubject
    shouldComparePreviewText
    shouldCompareContent
    fallbackEdition
    winningMetric
    startTime
    testPeriodLength {
        unit
        timespan
    }
    sendPercentage
    winnerEdition {
        id
        name
        status
        sendTime
        htmlUrlPath
        viewInBrowserLink
        emailTemplate {
            id
            thumbnailUrl
            subject
            previewText
            modifiedTime
            beeBodyJson
        }
    }
    engagementStats {
        totalSentCount
    }
    winningEdition {
        id
    }
}
